<script>
	import { api_engage } from "./stores.js";
	export let entity_id;
	export let entity_url;
	export let idx;

	let video;
	let mute = true;
	let pause = false;
	let viewportHeight = document.documentElement.clientHeight;
	let scrollDirection;
	let scrollPos = 0;
	let engageTime = 0;
	let lastViewTime = 0;

	// detect scroll direction
	window.onscroll = function (e) {
		if (this.oldScroll > this.scrollY) {
			scrollDirection = "up";
		} else {
			scrollDirection = "down";
		}
		this.oldScroll = this.scrollY;
		scrollPos = this.oldScroll;
	};

	const pauseNeighbourVideos = () => {
		let allVideoElements = document.querySelectorAll("video");
		for (let i = allVideoElements.length; i--; ) {
			let elm = allVideoElements[i];
			if (elm !== video) elm.pause();
		}
	};

	const getLastViewTime = (entity_id) => {
		let entities_engage = JSON.parse(
			localStorage.getItem("entities_engage")
		);
		if (entities_engage && entities_engage[entity_id]) {
			lastViewTime = entities_engage[entity_id].lastViewTime;
		}
		return lastViewTime;
	};
	getLastViewTime(entity_id);

	const handleMove = (e) => {
		video = e.srcElement;
		engageTime = +new Date();
		lastViewTime = getLastViewTime(entity_id);
		if (video.muted !== mute) {
			mute = video.muted;
			console.log("video mute update:", mute, idx, entity_id);
			writeUserVideoEngagement("videomute_" + mute);
		}
		if (video.paused !== pause) {
			pause = video.paused;
			console.log("video pause update:", pause, idx, entity_id);
			writeUserVideoEngagement("videopause_" + pause);
		}
		if (!video.paused) pauseNeighbourVideos();
	};

	// TODO: is there computationall cheaper solution?
	const triggerWhenScreenMiddle = (e) => {
		let allVideoElements = document.querySelectorAll("video");
		for (let i = allVideoElements.length; i--; ) {
			let elm = allVideoElements[i],
				pos = elm.getBoundingClientRect(),
				topPerc = (pos.top / viewportHeight) * 100,
				bottomPerc = (pos.bottom / viewportHeight) * 100,
				middle = (topPerc + bottomPerc) / 2,
				inViewport = middle > 25 && middle < 60;
			if (inViewport) elm.play();
			else elm.pause();
		}
	};
	$: if (scrollPos) triggerWhenScreenMiddle();
	window.addEventListener("resize", triggerWhenScreenMiddle);

	async function writeUserVideoEngagement(engageType) {
		console.log("Writing user video engagement...");
		const resp = await fetch($api_engage, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				user_id: localStorage.getItem("user_id"),
				entity_id: entity_id,
				condition: localStorage.getItem("condition"),
				experiment_id: localStorage.getItem("experiment_id"),
				engagement_type: engageType,
				response: 1,
				time_content_viewed: lastViewTime, // last inview time (epoch time ms)
				time_engagement: engageTime, // engage time (epoch time ms)
				// rt: engageRT, // RT (ms): engage time minus last view time
			}),
		});
		const response = await resp.json();
		if (response.success === "true") {
			console.log("Write/post video engagement successfully");
		} else {
			console.log("Fail to write/post video engagement");
		}
	}
</script>

<div class="media-card-entity">
	<!-- to play on iOS: https://stackoverflow.com/a/66344245/4727203 -->
	<video
		controls
		autoplay
		loop
		muted
		playsinline
		on:mousemove={handleMove}
		on:touchmove|preventDefault={handleMove}
	>
		<source src={entity_url} type="video/mp4" />
	</video>
</div>

<style>
	.media-card-entity {
		display: block;
		border-radius: 0.5rem;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 5px;
		max-width: 100%;
	}

	video {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	@media (max-width: 700px) {
		.media-card-entity {
			padding-bottom: 13px !important;
			padding-top: 13px !important;
		}
	}

	div {
		position: relative;
	}
</style>
